import properties from "./properties";

const getRedirectUri = () => window.location.origin + "/callback";
const getLogoutRedirectUri = () => window.location.origin + "/logout-succeeded";

const logout_Url = properties.Auth.logout_url;
const getLogoutUrl = () => {
  const logoutUrl = new URL(logout_Url);
  logoutUrl.searchParams.set("redirect_uri", getRedirectUri());
  logoutUrl.searchParams.set("logout_uri", getLogoutRedirectUri());
  return logoutUrl.toString();
};

export const getOidcSettings = () => ({
  authority: properties.Auth.authority,
  responseType: "code",
  scope: "openid profile",
  client_id: properties.Auth.clientId,
  redirect_uri: getRedirectUri(),
  post_logout_redirect_uri: getLogoutRedirectUri(),
  loadUserInfo: false,
  automaticSilentRenew: true,
  metadata: {
    authorization_endpoint: properties.Auth.authority,
    token_endpoint: properties.Auth.token_url,
    end_session_endpoint: getLogoutUrl(),
  },
});
